export default {
  computed: {
    $typeAheadRelations() {
      return [
        { value: null, text: "optional" },
        { value: "mother", text: "Mother" },
        { value: "father", text: "Father" },
        { value: "sister", text: "Sister" },
        { value: "brother", text: "Brother" },
        { value: "daughter", text: "Daughter" },
        { value: "son", text: "Son" },
        { value: "aunt", text: "Aunt" },
        { value: "uncle", text: "Uncle" },
        { value: "brotherinlaw", text: "Brother-In-Law" },
        { value: "sisterinlaw", text: "Sister-In-Law" },
        { value: "stepmother", text: "Step Mother" },
        { value: "stepfather", text: "Step Father" },
        { value: "churchmember", text: "Church Member" },
        { value: "pastor", text: "Paster" },
        { value: "babymama", text: "Baby Mana" },
        { value: "babydaddy", text: "Baby Daddy" },
        { value: "boyfriend", text: "Boyfriend" },
        { value: "girlfriend", text: "Girlfriend" },
        { value: "caregiver", text: "Caregiver" },
        { value: "cousin", text: "Cousin" },
        { value: "daughterinlaw", text: "Daughter-In-Law" },
        { value: "doctor", text: "Doctor" },
        { value: "fatherinlaw", text: "Father-In-Law" },
        { value: "fiance", text: "Fiance" },
        { value: "fiancee", text: "Fiancee" },
        { value: "friend", text: "Friend" },
        { value: "granddaughter", text: "Granddaugher" },
        { value: "grandfather", text: "Grandfather" },
        { value: "grandmother", text: "Grandmother" },
        { value: "grandson", text: "Grandson" },
        { value: "husband", text: "Husband" },
        { value: "motherinlaw", text: "Mother-in-Law" },
        { value: "neighbor", text: "Neighbor" },
        { value: "nephew", text: "Nephew" },
        { value: "niece", text: "Niece" },
        { value: "soninlaw", text: "Son-in-Law" },
        { value: "stepdaughter", text: "Step Daughter" },
        { value: "stepson", text: "Step Son" },
        { value: "uncle", text: "Uncle" },
        { value: "wife", text: "Wife" },
        { value: "teacher", text: "Teacher" },
        { value: "coach", text: "Coach" },
      ];
    }
  }
};
